export interface PlasticsColorCode {
    id: string;
    code: string;
    name: string;
    hexValue: string;
    createdOn: Date;
    createdById: string;
    updatedOn: Date;
    updatedById: string;
}

export const DEFAULT_PLASTICS_COLOR_CODE: PlasticsColorCode = {
    id: '',
    code: '',
    name: '',
    hexValue: '#ffffff',
    createdOn: null as unknown as Date,
    createdById: '',
    updatedOn: null as unknown as Date,
    updatedById: '',
};
